import { Group, Paper, Stack, Switch } from '@common/ui'
import TrimmedTextInput from './TrimmedTextInput'
import { com } from '@eidu/web'
import SchoolDropDown = com.eidu.sharedlib.form.definition.SchoolDropDown
import { withKey } from '../../util/withKey'
import FormKeyField from './FormKeyField'

type SchoolDropDownItemProps = {
  item: SchoolDropDown
  onChange?: (item: SchoolDropDown) => void
}

const SchoolDropDownItem: React.FC<SchoolDropDownItemProps> = ({ item, onChange }) => (
  <Paper withBorder radius="sm" p="xs">
    <Stack gap="md">
      <Group gap="md" wrap="nowrap" align="flex-start">
        <TrimmedTextInput
          style={{ flex: 1 }}
          label="Prompt"
          value={item.prompt}
          onChange={(e) =>
            onChange?.(
              withKey(item.copy(e.target.value, item.key, item.required, item.unfilledText, item.placeholder), item)
            )
          }
          disabled={!onChange}
        />
        <FormKeyField
          value={item.key}
          onChange={(e) =>
            onChange?.(
              withKey(item.copy(item.prompt, e.target.value, item.required, item.unfilledText, item.placeholder), item)
            )
          }
          disabled={!onChange}
        />
      </Group>

      <Group gap="md" wrap="nowrap" align="center">
        <TrimmedTextInput
          style={{ flex: 1 }}
          label="Unfilled Text"
          value={item.unfilledText ?? ''}
          onChange={(e) =>
            onChange?.(withKey(item.copy(item.prompt, item.key, item.required, e.target.value, item.placeholder), item))
          }
          disabled={!onChange}
        />
        <TrimmedTextInput
          style={{ flex: 1 }}
          label="Placeholder"
          value={item.placeholder ?? ''}
          onChange={(e) =>
            onChange?.(
              withKey(item.copy(item.prompt, item.key, item.required, item.unfilledText, e.target.value), item)
            )
          }
          disabled={!onChange}
        />
        <Switch
          checked={item.required}
          onChange={(e) =>
            onChange?.(
              withKey(item.copy(item.prompt, item.key, e.target.checked, item.unfilledText, item.placeholder), item)
            )
          }
          disabled={!onChange}
          label="Required"
        />
      </Group>
    </Stack>
  </Paper>
)

export default SchoolDropDownItem
